<script setup lang="ts">
import { computed, useSlots } from 'vue';

interface Props {
  size?: 'small' | 'large'; //our design only have 2 sizes
  type?: 'primary' | 'default' | 'dashed' | 'text' | 'link'; //ant-d button types
  htmlType?: 'button' | 'submit' | 'reset';
  danger?: boolean;
  loading?: boolean;
  disabled?: boolean;
  block?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  size: 'large',
  type: 'primary',
  htmlType: 'button',
  danger: false,
  disabled: false,
  loading: false,
  block: false,
});

const hasIconLeft = computed(() => {
  return useSlots()?.iconLeft;
});

const hasIconRight = computed(() => {
  return useSlots()?.iconRight;
});
</script>

<template>
  <a-button shape="round" v-bind="props">
    <span v-if="!loading" class="btn-main-content">
      <span class="btn-flex-wrap">
        <span v-if="hasIconLeft" class="icon icon-left">
          <slot name="iconLeft" />
        </span>

        <span class="btn-text">
          <slot></slot>
        </span>

        <span v-if="hasIconRight" class="icon icon-right">
          <slot name="iconRight" />
        </span>
      </span>
    </span>
  </a-button>
</template>

<style lang="less" scoped>
.ant-btn.ant-btn-round {
  border-radius: @border-radius-button;
  padding-left: 0.71rem;
  padding-right: 0.71rem;
  height: 3.14rem;
  font-size: 1rem;
  font-weight: @font-weight-bold;

  &.ant-btn-sm {
    height: 2.14rem;
    font-size: 0.85rem;
  }
}

.ant-btn-primary[disabled],
.ant-btn-primary[disabled]:hover,
.ant-btn-primary[disabled]:focus,
.ant-btn-primary[disabled]:active,
.ant-btn[disabled],
.ant-btn[disabled]:hover,
.ant-btn[disabled]:focus,
.ant-btn[disabled]:active {
  background-color: fade(@color-primary, 10%);
  border-color: fade(@color-primary, 10%);
  color: @color-mid-tone;
}

.btn-flex-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-main-content {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  position: relative;
}

.icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  &.icon-left {
    left: 0px;
  }

  &.icon-right {
    right: 0px;
  }
}

.btn-text {
  white-space: normal;
}
</style>
